import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { getUrlParam } from 'core-components/helpers/url'
import { scrollElementIntoPage } from 'partner360/lib/planSectionDialog'

interface IUseScrollToUrlTarget {
  enabled: boolean
  urlKey: string
  watchKey?: string | number | boolean
  offset?: number
  delayMs?: number
  behavior?: ScrollBehavior
}

export const useScrollToUrlTarget = ({
  enabled,
  urlKey,
  watchKey,
  offset = 0,
  delayMs = 0,
  behavior = 'smooth',
}: IUseScrollToUrlTarget) => {
  const location = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined' || !enabled) {
      return
    }

    const targetKey = getUrlParam(urlKey, location.pathname)?.trim().toLowerCase()

    if (!targetKey) {
      return
    }

    const timeoutId = window.setTimeout(() => {
      const targetElement = document.getElementById(targetKey)

      if (!targetElement) {
        return
      }

      scrollElementIntoPage(targetElement, { offset, behavior })
    }, delayMs)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [behavior, delayMs, enabled, location.pathname, offset, urlKey, watchKey])
}
